import opDevCall from '@/mixins/op-dev-call.js';

const CACHE_TTL_MS = 86400000;
const CACHE = {};

const DEFAULT = { embed_root: null };

const orgLink = {
  mixins: [ opDevCall ],
  methods: {
    async getOrgLinkOpts(org_id) {
      if (!org_id)
        return DEFAULT;
      if (!CACHE[org_id] || ((new Date()) - CACHE[org_id].t > CACHE_TTL_MS))
        CACHE[org_id] = { t: new Date(), p: this.$call('get-org-link-props', { org_id }) };
      return await CACHE[org_id].p;
    },

    buildOrgLinkWithOpts(path, orgId, opts) {
      const { embed_root } = opts || DEFAULT;
      if (embed_root) {
        const url = new URL(embed_root);
        url.search = url.search + (url.search ? '&' : '?') + 'q=' + encodeURIComponent(path);
        return url.href;
      }
      return location.origin + '/' + path;
    },

    async buildOrgLink(path, orgId) {
      return this.buildOrgLinkWithOpts(path, orgId, await this.getOrgLinkOpts(orgId));
    }
  }
};

export { orgLink };
